import { Injectable, inject } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { Status } from '@df/core/status';

export interface IPostcodeResult {
    result: {
        latitude: number;
        longitude: number;
        postcode: string;
    }[];
}

export interface ILocation {
    latitude: number;
    longitude: number;
}

@Injectable({
    providedIn: 'root'
})
export class LocationPostcodeService {
    private requestService = inject(RequestService);
    private postcodeMap: Map<string, string> = new Map();

    private generateKey(location: ILocation): string {
        return `${location.latitude},${location.longitude}`;
    }

    async loadLocation(status: Status, cb: (postcode: string | undefined) => void): Promise<void> {
        try {
            status.busy = true;
            await navigator.geolocation.getCurrentPosition(
                async e => {
                    const location = {
                        latitude: e.coords.latitude,
                        longitude: e.coords.longitude
                    };
                    if (this.postcodeMap.has(this.generateKey(location))) {
                        status.busy = false;
                        cb(this.postcodeMap.get(this.generateKey(location)));
                        return;
                    }
                    const postcodeResult: IPostcodeResult = await this.requestService.sendXHR(
                        `https://api.postcodes.io/postcodes?lon=${location.longitude}&lat=${location.latitude}`,
                        undefined,
                        { method: 'GET' }
                    );
                    if (postcodeResult?.result?.[0]?.postcode) {
                        status.busy = false;
                        this.postcodeMap.set(this.generateKey(location), postcodeResult.result[0].postcode);
                        cb(postcodeResult.result[0].postcode);
                    } else {
                        status.busy = false;
                        status.error = 'Location information is unavailable.';
                    }
                },
                () => {
                    status.busy = false;
                    status.error = 'Location information is unavailable.';
                }
            );
        } catch (err: any) {
            status.busy = false;
            status.error = 'Location information is unavailable.';
        }
    }
}
